import React from 'react';
import { isFactorTv } from '@rnv/renative';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import WebApp from '../rnapp/WebApp';
import TvApp from '../rnapp/TvApp';

// Web / TV root. The TV shell (TvApp) renders shared kid screens —
// ProfileSelect, ChildHome, Player, EditChild — that call useSafeAreaInsets().
// That hook THROWS ("No safe area value available") unless a SafeAreaProvider
// is mounted above it. The native RootNavigator wraps one; this web/TV root
// needs its own or the whole app renders blank on Tizen/webOS (and in a
// browser preview). Insets resolve to 0 here (no notch on a TV / desktop),
// which is exactly what those screens want on this platform.
export const RootNavigator = () => {
  // Only the TV shell (TvApp) renders shared screens that call
  // useSafeAreaInsets, so only it needs the provider. Wrapping the Next.js web
  // (WebApp) in it too collapsed that layout to zero height (blank page) — the
  // web has always run provider-free, and its screens read insets via the
  // zero-fallback context (AuthShell), so keep the web path untouched.
  if (isFactorTv) {
    return (
      <SafeAreaProvider>
        <TvApp />
      </SafeAreaProvider>
    );
  }
  return <WebApp />;
};
